/**
 * Ce qu'on dit à un CGP devant une information réservée aux admins du
 * cabinet (logique pure, testée).
 *
 * Plutôt qu'un lien qui mène à une page refusée, le CGP voit pourquoi il
 * est bloqué, quoi demander, et à qui.
 */

import type { UserRead } from "@/lib/api/schema";

/** Les manques `cabinet.*` ne se complètent que dans les Réglages admin. */
export function isAdminOnlyMissingKey(key: string): boolean {
  return key.startsWith("cabinet.");
}

/** « Pour générer le DER, il manque : SIREN, numéro ORIAS. » */
export function missingReason(document: string, labels: readonly string[]): string | null {
  if (labels.length === 0) return null;
  return `Pour générer ${document}, il manque : ${labels.join(", ")}.`;
}

/** Noms des admins actifs du cabinet, dans l'ordre alphabétique. */
export function adminNames(users: readonly Pick<UserRead, "full_name" | "role" | "is_active">[]) {
  return users
    .filter((u) => u.role === "ADMIN" && u.is_active)
    .map((u) => u.full_name.trim())
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b, "fr"));
}

/** « Camille Martin », « Camille Martin ou Alex Durand », « A, B ou C ». */
export function formatAdminNames(names: readonly string[]): string | null {
  if (names.length === 0) return null;
  if (names.length === 1) return names[0]!;
  return `${names.slice(0, -1).join(", ")} ou ${names[names.length - 1]}`;
}

export const ADMIN_ONLY_TITLE = "Cette page est réservée aux administrateurs du cabinet";
export const ADMIN_ONLY_ASK = "Demandez à votre administrateur de compléter ces informations.";
